<template>
  <div class="">
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewItem"
          class="ml-1 mr-2"
        >
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="renew"
          class="ml-2 mr-2"
        >
          mdi-autorenew
        </v-icon>
      </template>
      <span>Extend Contract</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          color="error"
          v-on="on"
          v-bind="attrs"
          @click="closeItem"
          class="ml-2 mr-1"
        >
          mdi-close-circle
        </v-icon>
      </template>
      <span>Close Contract</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    viewItem() {
      this.params.context.parentComponent.viewContract(this.params.data.id);
    },
    renew() {
      this.params.context.parentComponent.showRenewDialog(this.params.data.id);
    },
    closeItem() {
      this.params.context.parentComponent.showCloseContractDialog(
        this.params.data.id
      );
    },
  },
};
</script>

<style></style>
